
export default {
  data() {
    return {
      hasImage: true,

      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "checkbox",
          label:
            "Ako želite da je naslov plave boje, označite kvadratić, u suprotnom će biti crn",
          type: "checkbox",
        },
      ],
    };
  },
  mounted() {
    const links = document.getElementsByClassName("hero-link");
    if (links && links.length && links[0] && links[0].children[0]) {
      links[0].children[0].removeAttribute("target");
    }
    if (
      this.$refs.image &&
      this.$refs.image &&
      this.$refs.image.sectionMeta.image
    ) {
      this.hasImage = true;
    } else this.hasImage = false;
  },
};
